<!--
 * @description: 维修--设备接受
 * @param: 
 * @return: 
-->
<template>
  <div class="user-management-container">
    <tabel-panel
      ref="tabel"
      :rowTemplate="rowTemplate"
      api="RepairReciveSearch"
      :condition="conditionData"
      editType="pop"
      :autoSearch="true"
      :showCancelButton="false"
      @popConfirmButtonClick="popConfirmButtonClick"
      :clickRowSelected="false"
      :popToCustomer="true"
    >
      <template v-slot:tabelTitleLeft>
        <div>设备接收列表</div>
      </template>

      <template v-slot:condition style="height: 200px">
        <text-field
          v-model:value="conditionData.compid"
          labelText="客户:"
          :clearable="true"
          type="select"
          :selectRemoteSearchData="selectOuguName"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.BrandId"
          labelText="品牌名称:"
          :clearable="true"
          type="select"
          :selectRemoteSearchData="selectOuguBrand"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.ProductId"
          labelText="产品类别:"
          ref="selectChild"
          :clearable="true"
          :type="selectChildData == null ? 'select' : 'selectChild'"
          :selectChildData="selectChildData"
          :selectRemoteSearchData="selectOuguNameProduct"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.ModelNoId"
          labelText="产品型号:"
          ref="selectChildMoid"
          :clearable="true"
          :type="selectChildData == null ? 'select' : 'selectChild'"
          :selectChildData="selectChildMoid"
          :selectRemoteSearchData="selectOuguNameModelSelect"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.sn"
          labelText="SN号:"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.TransferNo"
          labelText="货运单号:"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.staetime"
          type="date"
          labelText="申请起始日期:"
          clearable
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.end"
          type="date"
          labelText="申请截至日期:"
          clearable
          class="condition-container-input"
        >
        </text-field>
      </template>

      <template v-slot:receive="$opData">
        <div class="opration el-iconBtn">
          <i class="el-icon-check" @click="receiveBtn($opData.data.row, 0)"></i>
        </div>
      </template>
      <template v-slot:rejection="$opData">
        <div class="opration el-iconBtn">
          <i class="el-icon-error" @click="receiveBtn($opData.data.row, 1)"></i>
        </div>
      </template>

      <template v-slot:cancel="">
        <div class="opration el-iconBtn">
          <i class="el-icon-circle-close"></i>
        </div>
      </template>

      <template v-slot:oprator="$opData">
        <div class="opration">
          <del-border
            :useConfirm="true"
            comfirmMessage="确定删除吗？"
            comfirmOkText="确定"
            comfirmCancelText="取消"
            @buttonClick="delSingleUser($opData.data)"
          ></del-border>
        </div>
      </template>
    </tabel-panel>
  </div>
  <el-dialog
    center
    title="取消原因"
    v-model="rejectReason"
    :before-close="handleClose"
    width="30%"
  >
    <el-input
      type="textarea"
      v-model="reason"
      placeholder="请输入取消原因"
      rows="4"
    ></el-input>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="rejectReason = false" style="margin-right: 20px"
          >取 消</el-button
        >
        <el-button type="primary" @click="handleOk" style="margin-left: 20px"
          >确 定</el-button
        >
      </span>
    </template>
  </el-dialog>

  <pop-dialog
    id="loadBOX"
    v-if="receiveBox"
    ref="getMenuList2"
    :boxMaxWidth="true"
    textButtons="提交"
    @dialogClose="receiveBox = false"
    @confirmClick="receiveSave"
  >
    <template v-slot>
      <div class="saveBox">
        <text-field
          :requird="true"
          :clearable="true"
          v-model:value="receiveSaveReciveApp"
          labelText="接收备注:"
          class="condition-container-input"
        >
        </text-field>
      </div>
    </template>
  </pop-dialog>
</template>

<script>
import textField from "@/components/textField.vue";
import tabelPanel from "@/components/tabelPanel.vue";
import tableApi from "@/api/tabel.js";
import {
  ChangeRepairDelete,
  ChangeRepairDetailStateById,
  RepairDetectEditChangeState,
  RepairStateByState,
} from "@/api/index.js";
import { errMsg, successMsg } from "@/notify/index.js";
import delBorder from "@/components/delBorder.vue";
import popDialog from "@/components/popDialog.vue";

export default {
  name: "RepairDetec",
  components: {
    popDialog,
    textField,
    tabelPanel,
    delBorder,
  },
  data() {
    return {
      ID: null,
      reason: null,
      rejectReason: null,
      inputValue: "明细",
      activeName: "second",
      loadShow: false,
      saveBOX: false,
      rowTemplate: [
        {
          headerLabel: "维修状态",
          width: 80,
          dataIndex: "State",
        },
        {
          headerLabel: "递送方式",
          width: 90,
          sortable: true,
          dataIndex: "NotExpressName",
        },
        {
          headerLabel: "产品",
          width: 100,
          sortable: true,
          dataIndex: "ProCateName",
        },
        {
          headerLabel: "型号",
          width: 90,
          sortable: true,
          dataIndex: "ModelNoName",
        },
        {
          headerLabel: "SN",
          sortable: true,
          dataIndex: "SerialNoName",
          width: 150,
          dataRender: (v, { $index, column, row }) => {
            return (
              '<span style="color:' +
              (row.Distinguish == 1
                ? "green"
                : row.Distinguish == 2
                ? "blue"
                : row.Distinguish == 3
                ? "red"
                : "") +
              '">' +
              v +
              ""
            );
          },
        },
        {
          headerLabel: "邮寄单号",
          sortable: true,
          width: 180,
          dataIndex: "TransferNo",
        },
        {
          headerLabel: "症状信息",
          sortable: true,
          width: 100,
          dataIndex: "CusApp",
        },
        {
          headerLabel: "备注",
          width: 60,
          dataIndex: "IllDesc",
        },
        {
          headerLabel: "附件",
          width: 80,
          dataIndex: "AttachName",
        },
        {
          headerLabel: "维修中心",
          sortable: true,
          width: 100,
          dataIndex: "ServerName",
        },
        {
          headerLabel: "客户名称", //0
          width: 160,
          sortable: true,
          dataIndex: "CompName",
        },
        {
          headerLabel: "客户姓名", //0
          width: 100,
          dataIndex: "AddUser",
        },
        {
          headerLabel: "联系电话", //0
          width: 120,
          dataIndex: "TelNo",
        },
        {
          headerLabel: "接收日期", //0
          dataIndex: "ReciveDate",
          width: 120,
          sortable: true,
        },
        {
          headerLabel: "接收备注", //0
          dataIndex: "Appendix",
        },
        {
          headerLabel: "客户邮箱", //0
          width: 180,
          dataIndex: "Email",
        },
        {
          headerLabel: "是否返修", //0
          width: 80,
          dataIndex: "BackRepair",
          dataRender: (v) => {
            if (v == true) {
              return "是";
            } else if (v == false) {
              return "否";
            } else {
              return v;
            }
          },
        },
        {
          headerLabel: "接收", //0
          slot: "receive",
          width: 45,
          fixed: "right",
        },
        {
          headerLabel: "取消", //0
          slot: "rejection",
          width: 45,
          fixed: "right",
        },
        // { fixed: "right",
        // 	headerLabel: "取消",
        // 	slot: "cancel",
        // 	width: 45,
        // },
        {
          headerLabel: "删除",
          slot: "oprator",
          width: 45,
        },
      ],
      conditionData: {
        compid: null,
        BrandId: null,
        ProductId: null,
        ModelNoId: null,
        TransferNo: null,
        sn: null,
        staetime: null,
        end: null,
      },
      saveEdit: null,
      selectData: [
        {
          label: "有实物快递",
          value: 63,
        },
        {
          label: "无实物快递",
          value: 64,
        },
      ],
      ModelIllData: null,
      RepairDetectEdit: {
        id: 0, //Int	维修信息id	是
        result: "", //String	实际检测结果	是
        actills: "", //String	实际症状类型	是
        noexp: "", //String	递送方式	是
      },
      rules: {
        noexp: [
          {
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
        actills: [
          {
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
      },
      receive: 0,
      selectChildData: null,
      selectChildMoid: null,
      receiveBox: null,
      receiveSaveReciveApp: "",
    };
  },
  watch: {
    "conditionData.BrandId"(newV, oldV) {
      this.$refs.selectChild.stringValue = "";
      if (newV) {
        this.selectOuguNameProduct(newV);
        return;
      }
      this.selectChildData = null;
    },
    "conditionData.ProductId"(newV, oldV) {
      this.$refs.selectChildMoid.stringValue = "";
      if (newV) {
        this.selectOuguNameModelSelect(newV);
        return;
      }
      this.selectChildMoid = null;
    },
  },
  created() {
    this.flagWt();
  },
  methods: {
    //   弹出框关闭前的回调
    handleClose() {
      this.rejectReason = false;
      this.reason = null;
    },
    // 弹出框确定按钮
    handleOk() {
      if (!this.reason) {
        errMsg("请输入取消原因");
        return;
      }
      let parms = {
        Id: this.ID,
        State: 4,
        note: this.reason,
      };

      console.log("parms--", parms);
      parms = JSON.stringify(parms);
      RepairStateByState({ data: parms }).then((data) => {
        if (data.code == 0) {
          this.rejectReason = false;
          successMsg(data.message);
          this.reloadData();
        } else {
          this.rejectReason = false;
          errMsg(data.message);
        }
      });
    },
    // 根据用户登录权限的不同显示不同的表格项--是否有删除项
    async flagWt() {
      const obj = {
        page: 1,
        limit: 20,
      };
      const {
        data: { flag },
      } = await tableApi.RepairReciveSearch(obj);
      if (flag != 1) {
        this.rowTemplate.pop();
      }
    },
    /**
     * @description: 获取客户下拉框数据
     * @param {*}
     * @return {*}
     */
    async selectOuguName() {
      let source = await tableApi.CompanyInfo();
      if (source.code == 0) {
        let data = source.data.list.map(({ Company_Id, CompName }) => {
          return {
            label: CompName,
            value: Company_Id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    /**
     * @description: 三级联动一级数据
     * @param {*}
     * @return {*}
     */
    async selectOuguBrand() {
      let source = await tableApi.BrandSelect();
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    /**
     * @description: 三级联动 二级下拉框数据
     * @param {*} Bid---一级数据id
     * @return {*}
     */
    async selectOuguNameProduct(Bid) {
      let source;
      if (this.selectChildData == null) {
        source = await tableApi.ProductSelect();
      } else {
        source = await tableApi.ProductSelect({ Bid });
      }
      this.selectChildData = source.data.list;
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    /**
     * @description: 三级联动 三级数据
     * @param {*} ProductCategoryId--二级数据id
     * @return {*}
     */
    async selectOuguNameModelSelect(ProductCategoryId) {
      let source;
      if (this.selectChildMoid == null) {
        source = await tableApi.modelSelect();
      } else {
        source = await tableApi.modelSelect({ ProductCategoryId });
      }
      this.selectChildMoid = source.data.list;
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    // 重新加载表格数据
    reloadData() {
      this.$refs.tabel.reloadData();
    },
    // 删除单个数据项
    delSingleUser({ row }) {
      let { Id: id } = row;
      ChangeRepairDelete({ id }).then((data) => {
        if (data.code == 0) {
          successMsg(data.message);
          this.reloadData();
        } else {
          errMsg(data.message);
        }
      });
    },
    // 没用到
    handlePop(row) {
      this.saveEdit = row;
      this.addModelIllSelect(row.ProCate_Id);
      this.saveBOX = true;
      console.log("this.saveEdit", this.saveEdit);
      this.$nextTick(() => {
        this.$refs.getMenuList.showPopDialog(
          { row },
          "维修检测编辑信息",
          "slot"
        );
      });
    },
    // 产品症状类型
    addModelIllSelect(ProductCategoryId) {
      tableApi.ModelIllSelect({ ProductCategoryId }).then((data) => {
        if (data.code == 0) {
          this.ModelIllData = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
    },
    // 保存api
    listDataSave({ slotData }) {
      this.$refs["saveEdit"].validate((valid) => {
        if (valid) {
          this.RepairDetectEdit.id = slotData.row.Id;
          let parms = this.RepairDetectEdit;
          RepairDetectEditChangeState(parms).then((data) => {
            if (data.code == 0) {
              this.saveBOX = false;
              successMsg(data.message);
              this.reloadData();
            } else {
              errMsg(data.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //弹层事件
    popConfirmButtonClick({ slotData }) {
      console.log(slotData);
    },
    // 接收按钮
    receiveBtn(slotData, num) {
      console.log("error submit!!");
      this.ID = slotData.Id;
      if (num === 1) {
        this.rejectReason = true;
        this.ID = slotData.Id;
        return;
      }
      this.receiveBox = true;
      this.$nextTick(() => {
        this.$refs.getMenuList2.showPopDialog(null, "接收备注", "slot");
      });
    },
    receiveSave() {
      let parms = {
        Id: this.ID,
        State: 3,
        note: "",
        ReciveApp: this.receiveSaveReciveApp,
      };
      if (!this.receiveSaveReciveApp) {
        errMsg("接收备注不能为空");
        return;
      }
      console.log("parms--", parms);
      parms = JSON.stringify(parms);
      RepairStateByState({ data: parms }).then((data) => {
        if (data.code == 0) {
          successMsg(data.message);
          this.reloadData();
          this.receiveSaveReciveApp = "";
        } else {
          errMsg(data.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~@/assets/styles/_handle.scss";

#suerSwitch .el-switch__core {
  width: 26px;
}

.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: red;
}

.user-management-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  align-items: center;
  align-content: center;
  @include background_color("user-management-bg-color");
  .del {
    margin-left: 10px;
  }

  .condition-container-input {
    width: 270px;
  }

  .opration {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;

    .item {
      &:nth-child(n + 1) {
        margin-left: 10px;
      }
    }
  }
  .menuPowerBOX {
    .el-button--default {
      width: 90px;
      height: 30px;
      color: #ffffff;
      background: rgb(100, 134, 232);
      border-radius: 4px;
    }
    .item {
      height: 30px;
      color: #ffffff !important;
      padding: 10px 15px !important;
      background: rgb(100, 134, 232) !important;
    }
  }

  ::v-deep .el-table--scrollable-x .el-table__body-wrapper {
    overflow: auto !important;
  }
  ::v-deep .el-table__fixed-right-patch {
    background-color: #f5f7fa !important;
  }

  .el-row {
    margin-bottom: 16px;
  }
  .saveBox {
    padding-bottom: 20px;
  }
  .el-iconBtn {
    i {
      font-size: 30px;
      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
